import { createStyles } from '@material-ui/core/styles';

export default () => createStyles({
  filterContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '30px',
  },
});
